import * as R from 'ramda';
import _ from 'lodash';
import memoize from 'lodash/memoize';

/**
 * 텍스트 변환 함수
 */
const convertSnakeCase = (str) => {
    // Check snake_case pattern: /^([a-z]{1,})(_[a-z0-9]{1,})*$/
    const isSnakeCase = /^([a-z]{1,})(_[a-z0-9]{1,})*$/.test(str);
    if (isSnakeCase) {
        return _.camelCase(str);
    }
    return str;
};
export const refineRawText = memoize((input) => {
    // Set default value (equivalent to R.defaultTo(''))
    const value = input || '';

    // Process snake_case conversion
    const processed = convertSnakeCase(value);

    // Check if all characters are uppercase (equivalent to R.all((v) => R.equals(R.toUpper(v), v)))
    const chars = processed.split('');
    const isAllUpperCase = chars.every((char) => char === char.toUpperCase());

    if (isAllUpperCase) {
        // Return as is (equivalent to R.identity)
        return processed;
    }

    // Split first character and rest (equivalent to R.splitAt(1))
    const [first, ...restChars] = chars;
    const rest = restChars.join('');

    // Transform uppercase letters and add spaces as needed
    const transformedRest = rest.replace(/[A-Z]/g, (v, idx, full) => {
        if (idx <= 0) return v;
        const before = full[idx - 1];
        const maybeNumber = R.is(Number, Number(before));
        const isBeforeUpperCase = before === before.toUpperCase();

        const lowered = v.toLowerCase();

        return !maybeNumber || isBeforeUpperCase ? v : ` ${lowered}`;
    });

    // Capitalize first character and join (equivalent to R.join(''))
    return first.toUpperCase() + transformedRest;
});
